import { addNotification } from 'containers/Notifications/notificationsSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { toLongDate, toTime } from 'utils/date'
import { displayPrice } from 'utils/string'
import { useReduxDispatch } from 'store'
import React from 'react'

interface OutsourcePhotoProps {
  date: string
}

const OutsourcePhoto: React.FC<OutsourcePhotoProps> = ({ date }) => {
  const dateObject = new Date(`${date}T18:00`)
  const { t, lang } = useTranslation('warehouse')
  const dispatch = useReduxDispatch()

  return (
    <>
      <div className='title'>
        <div>{t('requestStorageInspection')}</div>
      </div>

      <div className='resignation__main'>
        <div className='resignation__list'>
          <div className='resignation__info'>{t('cannotTakeEndOfRentalPhoto')}</div>

          <div className='resignation__block__wrapper'>
            <div className='resignation__block__label'>{t('whatExactlyDoWeDo')}</div>
            <div className='resignation__block'>
              <div>
                <i className='icon icon--check cPrimary' />
                <span>{t('weWillCheckIfStorageIsEmpty')}</span>
              </div>
              <div>
                <i className='icon icon--check cPrimary' />
                <span>{t('weWillVerifyIfItIsClean')}</span>
              </div>
              <div>
                <i className='icon icon--check cPrimary' />
                <span>{t('weWillEndRentalForYou')}</span>
              </div>
            </div>
          </div>

          <div className='resignation__block__wrapper'>
            <div className='resignation__block__label'>{t('whenWillWeDoIt')}</div>
            <div className='resignation__block'>
              <div>
                <i className='icon icon--clock cPrimary' />
                <span>{t('afterDate')} {toLongDate(dateObject, lang, true)} {t('afterHour')} {toTime(dateObject, lang)}</span>
              </div>
            </div>
          </div>

          <div className='resignation__price'>
            <div className='resignation__price__top'>{t('serviceCost')}</div>
            <div className='resignation__price__bottom'>{displayPrice(20)}</div>
          </div>
        </div>

        <div className='resignation__buttons'>
          <ArrowBtn
            enlarged
            text={`${t('request')} (${displayPrice(20)})`}
            action={() => {
              dispatch(addNotification({ type: 'info', message: t('featureComingSoon') }))
            }}
          />

          <BackBtn
            text={t('cancel')}
          />
        </div>
      </div>
    </>
  )
}

export default OutsourcePhoto